import { Router, Switch, Route } from 'react-router-dom';
import React from 'react';
import { createMemoryHistory, createBrowserHistory } from 'history';
import ReactRouter from './ReactRouter';

import { browserUrlToReactUrl, reactUrlToBrowserUrl } from '../../urlParse';
import { pushError } from '../../pushError';
import {
  injectPhpDebug,
  replaceAllComplex,
  umcodeURL,
} from '../../mol_function';

import {
  ConsentEnum,
  hasConsent,
} from '../../Page/components/pages/Basepage/parts/CookieManager';

import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { v4 as uuidv4 } from 'uuid';

import '../style/index.scss';

let browserUrl = null;
let apidata = null;
let memoryHistory = null;

let sentryEnvironment = 'prodouction';

if (process.env.SENTRY_ENVIRONMENT) {
  sentryEnvironment = process.env.SENTRY_ENVIRONMENT;
}

try {
  if (window.renderCtrItem != null) {
    browserUrl = window.renderCtrItem.reactUrl;
    apidata = window.renderCtrItem.apidata;
  } else {
    let pathname = window.location.pathname;
    let search = window.location.search;

    browserUrl = browserUrlToReactUrl(pathname, search);
  }

  let initRoute = browserUrl;

  try {
    decodeURI(location.pathname);
  } catch (error) {
    let newUrl = umcodeURL(location.pathname);

    try {
      decodeURI(newUrl);
      window.history.pushState(null, document.title, newUrl);
    } catch (error5) {
      pushError('ReactEnty.UTF8URL', {
        org: location.pathname,
        newUrl: newUrl,
      });
    }
  }

  let browserHistory = createBrowserHistory();
  memoryHistory = createMemoryHistory({ initialEntries: [initRoute] });

  window.historyHelper = {
    browser: browserHistory,
    memory: memoryHistory,
    pushError: pushError,
  };

  browserHistory.listen((lh) => {
    try {
      let react = browserUrlToReactUrl(lh.pathname, lh.search);
      if (react.endsWith('?')) {
        react = react.substring(0, react.length - 1);
      }
      let currentLoc = memoryHistory.location;
      let curentUrl = currentLoc.pathname + currentLoc.search;
      if (curentUrl != react && react != '') {
        //debugger;
        //console.log('Broswer Redirect ', curentUrl, ' -> ', react);
        memoryHistory.push(react, null);
      }
    } catch (error4) {
      pushError('browserHistory.listen', error4);
    }
  });

  memoryHistory.listen((lm) => {
    try {
      if (lm.pathname == '/extern') {
        let url = lm.state;
        window.location = url;
      } else {
        let traceID = uuidv4();

        let traceIDRAW =
          traceID.substr(0, 8) +
          traceID.substr(9, 4) +
          traceID.substr(14, 4) +
          traceID.substr(19, 4) +
          traceID.substr(24, 12);

        let transactionName = null;

        try {
          transactionName = reactUrlToTransactionName(lm.pathname);
        } catch {}

        if (transactionName != null)
          Sentry.configureScope((scope) => {
            scope.setTag('transaction_id', traceIDRAW);
            scope.setTransactionName(transactionName);
          });

        window.historyHelper.traceID = traceID;

        let url = reactUrlToBrowserUrl(lm.pathname, lm.search, null);
        let oldUrl =
          browserHistory.location.pathname + browserHistory.location.search;
        if (url != '' && oldUrl != url) {
          //console.log('Memory Redirect ', oldUrl, ' -> ', url);
          if (lm.hash == '') {
            window.scrollTo(0, 0);
            browserHistory.push(url, null);
          } else {
            browserHistory.push(url + lm.hash, null);
          }
        }
      }
    } catch (error3) {
      pushError('memoryHistory.listen', error3);
    }
  });

  let reactLink = reactUrlToBrowserUrl(initRoute, null, apidata);
  let broserLoc = browserHistory.location;
  let broserUrl = broserLoc.pathname + broserLoc.search;

  if (broserUrl != reactLink) {
    browserHistory.replace(reactLink, null);
  }

  let sentryDSN = null;

  let sentryTunnel = injectPhpDebug(
    window.renderCtrItem.apidata.domainApi + '/Sentry.php',
  );

  if (process.env.SENTRY_REACT_DSN) {
    sentryDSN = process.env.SENTRY_REACT_DSN;
  }

  if (sentryDSN != null && hasConsent(ConsentEnum.SENTRY)) {
    let sentryOptions = {
      dsn: sentryDSN,
      tunnel: sentryTunnel,
      integrations: [
        new Integrations.BrowserTracing({
          routingInstrumentation:
            Sentry.reactRouterV5Instrumentation(memoryHistory),
          tracingOrigins: [
            'www.buchbutler.moluna.intranet',
            'api.buchbutler.moluna.intranet',
            'www.buchbutler.de',
            'api.buchbutler.de',
            // API der jeweiligen Umgebung (z.B. shopapi.docker-container-...)
            window.renderCtrItem.apidata.domainApi,
            /^\//,
          ],
        }),
      ],
      environment: sentryEnvironment,
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
    };

    if (process.env.CI_PIPELINE_ID != null) {
      sentryOptions.release =
        'buchbutler_shop_react@1.0.' + process.env.CI_PIPELINE_ID;
    }

    Sentry.init(sentryOptions);
  }
} catch (error) {
  pushError('JS-Client Init', error);
}

const ReactEntry = () => {
  try {
    let apidata = null;
    let mode = 'react';

    if (window.renderCtrItem != null) {
      let ctrItem = window.renderCtrItem;
      if (sentryEnvironment != 'prodouction' || module.hot != undefined) {
        localStorage.setItem('apidata', JSON.stringify(ctrItem.apidata));
      }
      window.renderCtrItem = null;
      apidata = ctrItem.apidata;
      mode = 'hydrate';
    } else if (module.hot != undefined) {
      mode = 'hot';
      apidata = localStorage.getItem('apidata');
    }

    let renderingUrl = window.location.origin;

    return (
      <div id="App">
        <Router history={memoryHistory}>
          <React.StrictMode>
            <ReactRouter
              apiData={apidata}
              mode={mode}
              renderingUrl={renderingUrl}
            />
          </React.StrictMode>
        </Router>
      </div>
    );
  } catch (error2) {
    pushError('ReactEnty Component', error2);
  }
};

export default ReactEntry;
